import { ValidatorService } from './tools/validator.service';
import { AutenticacionService } from './autenticacion.service';
import { Http, ResponseContentType, Headers, URLSearchParams } from '@angular/http';
import { ConstantsService } from './constants.service';
import { Injectable } from '@angular/core';
import { ErrorsService } from './tools/errors.service';
declare var $;

@Injectable()
export class PagaresService {

  private service_url : string = null;
  private contratosServiceUrl : string = null;
  constructor(
      private constantsService: ConstantsService, 
      private http: Http, 
      private authService: AutenticacionService) {
        this.service_url = this.constantsService.apiURL + '/pagares';
  }

  public download(idCreditos: number) {
    let myParams = new URLSearchParams();
    myParams.append('action', 'download');
    
    const options = this.authService.getAuthHeaders();
    options.params = myParams;

    let serviceUrl = this.service_url + '/' + idCreditos;
    options.responseType = ResponseContentType.Blob;
    return this.http.get(serviceUrl, options);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/pagares.service.ts